module.exports = __webpack_public_path__ + "static/media/button-prev-over.b66ad111.svg";